import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useDemo } from "../context/DemoContext";

export const CTASection = ({
  eyebrow = "Get in Touch",
  title = "Tell us what you're trying to solve.",
  body = "Whether it's a product demo or a consulting conversation, every enquiry reaches the right team — no switchboards, no generic inboxes.",
  productId = null,
}) => {
  const { openDemo } = useDemo();
  return (
    <section className="grain relative overflow-hidden bg-slate-900 py-20 sm:py-24" data-testid="cta-section">
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-blue-600/25 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-teal-600/20 blur-3xl"
        aria-hidden="true"
      />
      <div className="container-x relative">
        <Reveal>
          <span className="eyebrow !border-blue-500/30 !bg-blue-500/10 !text-blue-300">{eyebrow}</span>
          <h2 className="mt-5 max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {title}
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-300">{body}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={() => openDemo(productId)}
              className="btn-primary"
              data-testid="cta-book-demo"
            >
              Book a Demo <ArrowRight size={16} aria-hidden="true" />
            </button>
            <Link
              to="/contact"
              className="btn-secondary !border-slate-600 !bg-transparent !text-white hover:!border-blue-400 hover:!text-blue-300"
              data-testid="cta-contact-link"
            >
              Contact ZasyaOnline
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
